module.exports = __webpack_public_path__ + "img/dkv-major.da9f8838.png";